<template>
  <div class="container">
    <step-pic :step="step" :text="text" :picStr="imgSrc"></step-pic>
    <button class="btn-only btn-block" @click="next()" v-if="fromPage !== 'Setting'">下一步</button>
    <div class="btn-group" v-else>
      <button class="btn-block btn" @click="pre()">取消</button>
      <button class="btn-block btn" @click="next()">下一步</button>
    </div>
  </div>
</template>
<script>
import StepPic from '../../components/StepPic/StepPic.vue'
import Common from '../../assets/js/common.js'
export default {
  components: {
    StepPic
  },
  data () {
    return {
      fromPage: this.$route.query.pageName,
      step: '步骤一',
      text: '请先长按日历设备左键（前翻页）显示二维码。如二维码已显示，请直接点击“下一步”',
      imgSrc: Common.staticHref() + 'img/stepOne.png'
    }
  },
  methods: {
    next () {
      this.$router.push({path: '/StepTwo', query: {pageName: this.fromPage}})
    },
    pre () {
      this.$router.back(-1)
    }
  },
  mounted () {
    Common.setTitle('步骤一')
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/mixins.styl'
.container
  background #ffffff;
  .btn-only
    position absolute;
    bottom 3.3vh;
    width calc(100% - 30px);
    left 15px;
  .btn-group
    position absolute;
    bottom 3.3vh;
    width calc(100% - 30px);
    left 15px;
    rowSpaceBetween();
    .btn
      width 48%;
</style>


// WEBPACK FOOTER //
// src/pages/StepOne/StepOne.vue